export default __webpack_public_path__ + "static/media/Wayne.c77271b2.jpg";